import { BillingClient } from "@/lib/clients";
import { Plan, BillingInfo, PlanPricing, resolveHasPaymentError } from "@/lib/models";
import { ActionContext, ActionTree, GetterTree, MutationTree, Store } from "vuex";

const billingClient = new BillingClient();

// Stateの型定義
export interface BillingState {
  billingInfo: BillingInfo;
  plan: Plan;
  pricing: PlanPricing | null;
}

type Actions = {
  fetchBillingInfo: (this: Store<{}>, injectee: ActionContext<BillingState, {}>) => any;
  fetchPricing: (this: Store<{}>, injectee: ActionContext<BillingState, {}>) => any;
};

type Getters = {
  billingInfo(state: BillingState): BillingInfo;
  plan(state: BillingState): Plan;
  isFreePlan(state: BillingState, getters: { plan: Plan | undefined }): boolean;
  hasPaymentError(state: BillingState): boolean;
  invoiceUrl(state: BillingState): string | null;
  pricing(state: BillingState): PlanPricing | null;
};

const mutations: MutationTree<BillingState> = {
  setBillingInfo(state, payload: BillingInfo) {
    state.billingInfo = payload;
    state.plan = payload.plan;
  },
  setPricing(state, payload: PlanPricing) {
    state.pricing = payload;
  },
};

const actions: ActionTree<BillingState, {}> & Actions = {
  async fetchBillingInfo({ commit }) {
    const billingInfo = await billingClient.fetchBillingInfo();
    commit("setBillingInfo", billingInfo);
  },
  async fetchPricing({ commit }) {
    const pricing = await billingClient.getPlanPricing();
    commit("setPricing", pricing);
  },
};

const getters: GetterTree<BillingState, {}> & Getters = {
  billingInfo: (state) => state.billingInfo,
  plan: (state) => state.plan,
  isFreePlan: (state, getters) => ((getters.plan as Plan | undefined) ?? Plan.free) === Plan.free,
  hasPaymentError: (state) =>
    resolveHasPaymentError(state.billingInfo?.subscription?.renewalState, !!state.billingInfo?.invoiceUrl),
  invoiceUrl: (state) => state.billingInfo?.invoiceUrl || null,
  pricing: (state) => state.pricing,
};

export default {
  namespaced: true,
  state: {
    billingInfo: {},
    plan: Plan.free,
    pricing: null,
  } as BillingState,
  getters,
  actions,
  mutations,
};
